import React from 'react';
import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import { css } from '@emotion/core';

import { FCC } from '@/utils/types';

type SloQualityLozengeProps = {
  appearance?: ThemeAppearance;
  isBold?: boolean;
};

const SloQualityLozenge: FCC<SloQualityLozengeProps> = ({ children, appearance, isBold }) => (
  <span
    css={css`
      & > span {
        // Quality score can only be 1-10, so we set a min-width to ensure the
        // lozenge is always the same size so it visually looks better.
        min-width: 20px;
        display: inline-flex;
        justify-content: center;
      }
    `}
  >
    <Lozenge appearance={appearance} isBold={isBold}>
      {children}
    </Lozenge>
  </span>
);

export default SloQualityLozenge;
